<div class="input-group mb-2">
  <label class="date-label" for="d1">From</label>
  <div class="date-selector">
    <input id="d1" class="form-control" [placeholder]="options.from" name="d1" [(ngModel)]="startDateModel" ngbDatepicker #d1="ngbDatepicker" (ngModelChange)="onDateChange()" placement="bottom-left" [minDate]='minDateModel!' [maxDate]='maxDateModel ?? valuationDate!'>
    <button class="button-without-border fa fa-calendar" aria-label="Open Date Selector" (click)="d1.toggle()"></button>
  </div>
  <label class="date-label" for="d2"> &nbsp;&nbsp;To </label>
  <div class="date-selector">
    <input id="d2" class="form-control" [placeholder]="options.to" name="d2" [(ngModel)]="endDateModel" ngbDatepicker #d2="ngbDatepicker" (ngModelChange)="onDateChange()" placement="bottom-right" [minDate]='minDateModel!' [maxDate]='maxDateModel ?? valuationDate!'>
    <button class="button-without-border fa fa-calendar" aria-label="Open Date Selector" (click)="d2.toggle()"></button>
  </div>
  @if (options.quickSelect.length>0) {
    <select [(ngModel)]="dateRange" (ngModelChange)="onQuickSelect()" class="form-control w-auto mb-2 ml-4" aria-label="Select Period">
      <option>---</option>
      @for (opt of options.quickSelect; track opt) {
        <option [ngValue]="opt">{{opt === 'ytd' ? 'YEAR TO DATE' : 'LAST ' + opt + 'DAYS'}}</option>
      }
    </select>
  }
</div>
